import { Injectable } from '@angular/core';

@Injectable()
export class GlobalDataService {

  constructor() { }
  username = 'guest';
  encryptedPassword = '';
  loginError = false;
  showLoginPanel = false;
}
